<template>
  <v-expand-transition>
    <div id="tasklist" v-if="customerId" :class="tasklistStyle">
      <form>
        <v-autocomplete ref="taskselect" v-model="computedSelection" :items="items" :search-input.sync="search"
          :filter="() => { return true }" @click:prepend-inner="menuIconClick()" label="" item-value="id"
          prepend-inner-icon="mdi-menu" item-text="name" return-object multiple solo dense filled full-width loading
          :menu-props="{ maxHeight: '80%', overflowX: true }">

          <template v-slot:progress>
            <v-progress-linear
              :active="loading.getTasks || loading.updateTasks || loading.getProjects || loading.changeStatus"
              indeterminate absolute top height="4" color="orange">
            </v-progress-linear>
          </template>

          <template v-slot:selection="data">
            <!-- STATUS CHIP -->
            <v-chip v-if="data.item.isStatus" close @click:close="remove(data.item)" label>
              {{ language.t("Tasklist." + data.item.key) }}
            </v-chip>
            <!-- PROJECT CHIP -->
            <v-chip v-else close @click:close="remove(data.item)" label>
              {{ data.item.name }}
            </v-chip>
          </template>

          <template v-slot:item="data">
            <!-- is this one ever loaded? -->
            <template v-if="(typeof data.item !== 'object')">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>

            <!-- HEADER, WITH CLOSE FUNCTION -->
            <template v-else-if="(data.item.isHeader)">
              <!-- CHANGE ITEM NAME TO LANGUAGE SPECIFIC -->
              <v-list-item-subtitle>{{ language.t("Tasklist." + data.item.name) }}</v-list-item-subtitle>

              <!-- EACH SPECIFIC HEADER ARROW DIRECTION -->
              <v-list-item-action v-if="data.item.projectHeader">
                <v-icon>mdi-chevron-{{ hideProjects ? 'down' : 'up' }}</v-icon>
              </v-list-item-action>

              <v-list-item-action v-if="data.item.taskHeader">
                <v-icon>mdi-chevron-{{ hideTasks ? 'down' : 'up' }}</v-icon>
              </v-list-item-action>

              <v-list-item-action v-if="data.item.surveyHeader">

                <v-icon>mdi-chevron-{{ hideSurveys ? 'down' : 'up' }}</v-icon>
              </v-list-item-action>
            </template>

            <!-- STATUS ITEM -->
            <template v-else-if="data.item.isStatus">
              <v-list-item-avatar>
                <v-icon :color="data.item.color">
                  {{ data.item.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="v-list-item-bugfix">
                <v-list-item-title>
                  {{ language.t("Tasklist." + data.item.key) }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- PROJECT ITEM -->
            <template v-else-if="data.item.isProject">

              <v-list-item-avatar>
                <v-icon :color="data.item.color">
                  {{ data.item.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="v-list-item-bugfix">
                <v-list-item-title>
                  <v-tooltip bottom open-delay="200">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ data.item.name }}
                      </span>
                    </template>
                    <span>{{ data.item.name }}</span>
                  </v-tooltip>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- LOADING TEMPLATE FOR TASK -->
            <template v-else-if="data.item.isTaskIntersect">
              <v-list-item-content>
                <v-progress-circular indeterminate></v-progress-circular>
                <div v-intersect="endTaskIntersect" />
              </v-list-item-content>
            </template>

            <!-- LOADING TEMPLATE FOR SURVEY -->
            <template v-else-if="data.item.isSurveyIntersect">
              <v-list-item-content>
                <v-progress-circular indeterminate></v-progress-circular>
                <div v-intersect="endSurveyIntersect" />
              </v-list-item-content>
            </template>

            <!-- TASK OR SURVEY ITEM -->
            <template v-else>

              <v-list-item-avatar @click="openTask(data.item)">
                <v-icon :color="data.item.color">
                  {{ data.item.icon }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content @click="openTask(data.item)" class="v-list-item-bugfix">
                <v-list-item-title>

                  <v-tooltip v-if="data.item.checked" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on">mdi-sync</v-icon>
                    </template>
                    <span>{{ language.t("Tasklist.fileCheck") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom open-delay="200">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ data.item.name }}
                      </span>
                    </template>
                    <span>{{ data.item.name }}</span>
                  </v-tooltip>

                </v-list-item-title>

                <v-list-item-subtitle>
                  {{ data.item.date }}
                </v-list-item-subtitle>

              </v-list-item-content>

              <!-- COMPLETE, DELETE, RESET BUTTONS -->
              <v-hover v-slot="{ hover }">
                <v-list-item-action>

                  <!-- NEW TASK -->
                  <v-container class="pa-0" v-if="data.item.status === '__TASKSTATUSTYPE_NEW'">
                    <v-row>

                      <!-- TASK FROM SURVEY BUTTON -->
                      <v-col class="pa-0" v-if="data.item.survey">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon small :loading="loadingIds.includes(data.item.id)"
                              @click="createTask(data.item)">
                              <v-icon :color="hover ? 'green' : 'grey lighten-3'">mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ language.t("Tasklist.convertTask") }}</span>
                        </v-tooltip>
                      </v-col>

                      <!-- COMPLETE TASK BUTTON -->
                      <v-col class="pa-0" v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon small :loading="loadingIds.includes(data.item.id)"
                              @click="changeStatus(data.item, '__TASKSTATUSTYPE_DONE')">
                              <v-icon :color="hover ? 'green' : 'grey lighten-3'">mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ language.t("Tasklist.completeTask") }}</span>
                        </v-tooltip>
                      </v-col>

                      <!-- REMOVE TASK/SURVEY BUTTON -->
                      <v-col class="pa-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon small :loading="loadingIds.includes(data.item.id)"
                              @click="changeStatus(data.item, '__TASKSTATUSTYPE_REMOVED')">
                              <v-icon :color="hover ? 'red' : 'grey lighten-3'">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span v-if="data.item.survey">{{ language.t("Tasklist.removeSurvey") }}</span>
                          <span v-else>{{ language.t("Tasklist.RemoveTask") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-container>

                  <!-- COMPLETED OR REMOVED TASK -->
                  <v-container class="pa-0" v-else>
                    <v-row>
                      <v-col class="pa-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon small :loading="loadingIds.includes(data.item.id)"
                              @click="changeStatus(data.item, '__TASKSTATUSTYPE_NEW')">
                              <v-icon :color="hover ? 'green' : 'grey lighten-3'">mdi-refresh
                              </v-icon>
                            </v-btn>
                          </template>
                          <span v-if="data.item.survey">{{ language.t("Tasklist.restoreSurvey") }}</span>
                          <span v-else>{{ language.t("Tasklist.restoreTask") }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-action>
              </v-hover>

            </template>

          </template>
        </v-autocomplete>

        <!-- ADD TASK BUTTON -->
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon @click="addTask()" dark color="green darken-2" v-bind="attrs" v-on="on"
              :large="!$vuetify.breakpoint.xsOnly">
              mdi-plus-circle
            </v-icon>
          </template>
          <span>{{ language.t("Tasklist.createTask") }}</span>
        </v-tooltip> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-1" v-bind="attrs" v-on="on" @click="addTask()" dark fab small color="green darken-2"
              :disabled="taskOpen">
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <span>{{ language.t("Tasklist.createTask") }}</span>
        </v-tooltip>


      </form>
      <!-- CREATE SURVEY POPUP -->
      <TaskCreateSurvey v-if="createTaskFromSurvey" :task="this.taskCreateSurveyItem" v-on:close="closeTaskFromSurvey"
        v-on:update="resetTaskList()">
      </TaskCreateSurvey>

    </div>
  </v-expand-transition>
</template>

<script>
import moment from "moment";
import Task from "../models/Task";
import TaskCreateSurvey from "./robotplotter/TaskCreateSurvey";
import * as CONST from "../Constants.js";

export default {
  components: {
    TaskCreateSurvey,
  },
  data() {
    return {
      hideProjects: true,
      hideTasks: false,
      hideSurveys: false,

      surveyCancel: null,
      taskCancel: null,

      loading: {
        getTasks: false,
        getSurveys: false,
        updateTasks: false,
        getProjects: false,
        changeStatus: false,
      },

      loadingIds: [],

      selection: [{
        id: CONST.__TASKSTATUSTYPE_NEW,
        name: this.language.t("Tasklist.taskStatusNew"),
        key: 'taskStatusNew',
        icon: "mdi-square-rounded",
        color: "green",
        isStatus: true,
        dbId: 1
      }],

      items: [],
      tasks: [],
      surveys: [],
      projects: [],

      createTaskFromSurvey: false,
      taskCreateSurveyItem: null,

      searchTimeout: null,

      nextTaskPage: 1,
      nextSurveyPage: 1,

      search: null,
      taskOpen: false
    };
  },
  mounted: function () {
    if (this.$auth.customerId) {
      this.$nextTick(() => {
        this.getProjects();
      })
    }
  },
  computed: {
    customerId() {
      return this.$auth.customerId;
    },
    tasklistStyle: function () {
      return {
        floating: !this.$vuetify.breakpoint.xsOnly,
        inline: this.$vuetify.breakpoint.xsOnly,
      };
    },
    computedSelection:
    {
      get: function () {
        return this.selection
      },
      set: function (newValue) {
        let addedItem = newValue.filter(x => !this.selection.includes(x));
        let removedItem = this.selection.filter(x => !newValue.includes(x));
        this.selection = newValue

        if (addedItem.length > 0) {
          const item = addedItem[0]

          var skipAdd = false
          if (item.isTask || item.survey) {
            skipAdd = true;
            this.remove(item)
          } else if (item.isHeader) {
            this.remove(item)
            this.toggleHeader(item);
            skipAdd = true;
          }
          if (!skipAdd) {
            //reset tasklist
            this.resetTaskList()
          }
        }

        if (removedItem.length > 0) {
          if (!removedItem[0].isTask && !removedItem[0].survey && !removedItem[0].isHeader) {
            this.resetTaskList()
          }
        }
      }
    }
  },
  watch: {
    search() {
      this.debouncedSearch()
    },
    customerId(val) {
      if (Number.isInteger(val)) {
        this.resetTaskList();
        this.getProjects();
      }
    },
    tasks(val) {
      this.updateTasks();
      this.$emit("tasksFromTasklist", val);
    },
    surveys() {
      this.updateTasks();
    },
    projects() {
      this.updateTasks();
    },
    tasklistStyle() {
      if (this.$refs.taskselect.isMenuActive) {
        this.$refs.taskselect.isMenuActive = false;
        this.showTaskList();
      }
    },
  },
  methods: {
    endTaskIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.getTasks(true)
      }
    },
    endSurveyIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.getSurveys(true)
      }
    },
    debouncedSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {

        this.resetTaskList()
      }, 250);
    },
    closeTaskFromSurvey() {
      this.createTaskFromSurvey = false;
    },
    createTask(item) {
      this.taskCreateSurveyItem = item;
      this.createTaskFromSurvey = true;
    },
    toggleHeader(item) {
      if (item.projectHeader) {
        this.hideProjects = !this.hideProjects;
        this.updateTasks()
      }
      if (item.taskHeader) {
        this.hideTasks = !this.hideTasks;
        this.updateTasks()
      }
      if (item.surveyHeader) {
        this.hideSurveys = !this.hideSurveys;
        this.updateTasks()
      }
    },
    changeStatus(item, status) {
      console.log(item, status);
      this.loading.changeStatus = true;
      this.loadingIds.push(item.id);
      if (item.isTask || item.survey) {
        this.$axios.get(route("api.tasks.status", [item.taskId, status])).then(({ data: task }) => {
          if (item.isTask) {
            this.tasks[this.tasks.findIndex(item => item.taskId == task.taskId)] = task
          } else if (item.survey) {
            this.surveys[this.surveys.findIndex(item => item.taskId == task.taskId)] = task
          }
          this.updateTasks()

          this.loading.changeStatus = false;

          this.loadingIds.splice(this.loadingIds.indexOf(item.id), 1)
        });
      } else {
        this.loading.changeStatus = false;
        this.loadingIds.splice(this.loadingIds.indexOf(item.id), 1)
      }
    },
    closeTask() {
      this.taskOpen = false;
      this.resetTaskList()
      // Show tasklist again
      this.showTaskList();
    },
    updateTasks() {
      this.loading.updateTasks = true;

      var status = [
        {
          id: CONST.__TASKSTATUSTYPE_NEW,
          name: this.language.t("Tasklist.taskStatusNew"),
          key: 'taskStatusNew',
          icon: "mdi-square-rounded",
          color: "green",
          isStatus: true,
          dbId: 1
        },
        {
          id: CONST.__TASKSTATUSTYPE_DONE,
          name: this.language.t("Tasklist.taskStatusCompleted"),
          key: 'taskStatusCompleted',
          icon: "mdi-square-rounded",
          color: "blue",
          isStatus: true,
          dbId: 4
        },
        {
          id: CONST.__TASKSTATUSTYPE_REMOVED,
          name: this.language.t("Tasklist.taskStatusRemoved"),
          key: 'taskStatusRemoved',
          icon: "mdi-square-rounded",
          color: "red",
          isStatus: true,
          dbId: 5
        },
      ];
      status = [{ name: "tasklistHeaderStatus", isHeader: true }].concat(status, { divider: true });
      var selectionStatuses = this.computedSelection.filter((o) => o.isStatus === true);

      var projects;
      var selectionProjects = this.computedSelection.filter((o) => o.isProject === true);

      if (this.hideProjects){
        projects = selectionProjects
      } else {
        projects = this.projects.filter((o) => o.active === "1")
      }

      projects = [{ name: "tasklistHeaderProjects", isHeader: true, projectHeader: true }].concat(projects);

      var taskitems = [];
      for (let i = 0; i < this.tasks.length; i++) {
        const task = this.tasks[i]
        var statusFilter = false;
        var projectFilter = false;
        if (selectionStatuses.length > 0) statusFilter = selectionStatuses.some((o) => o.id === task.status);
        else statusFilter = true;
        if (selectionProjects.length > 0) projectFilter = selectionProjects.some((o) => o.projectId === task.project_projectId);
        else projectFilter = true;

        var itemfilter = statusFilter && projectFilter;
        if (!this.hideTasks) {
          if ((this.computedSelection.length == 0 || itemfilter)) {
            taskitems.push({
              id: "T" + task.taskId,
              status: task.status,
              project: task.project_projectId,
              name: task.name,
              taskId: task.taskId,
              checked: task.checked == 0 ? true : false,
              date: moment.utc(task.edited).local().format("YYYY-MM-DD HH:mm"),
              unix: moment.utc(task.edited).format("X"),
              icon: Task.getTaskIcon(task.operationPractice),
              color: Task.getTaskColor(task.status),
              isTask: true,
            });
          }
        }
      }

      var surveyitems = [];
      if (!this.hideSurveys) {
        for (let i = 0; i < this.surveys.length; i++) {
          const survey = this.surveys[i];

          var statusFilter = false;
          var projectFilter = false;
          if (selectionStatuses.length > 0) statusFilter = selectionStatuses.some((o) => o.id === survey.status);
          else statusFilter = true;
          if (selectionProjects.length > 0) projectFilter = selectionProjects.some((o) => o.projectId === survey.project_projectId);
          else projectFilter = true;

          if ((this.computedSelection.length == 0 || statusFilter)) {
            surveyitems.push({
              id: "T" + survey.taskId, // should this be S??
              status: survey.status,
              project: survey.project,
              name: survey.name,
              taskId: survey.taskId,
              checked: survey.checked == 0 ? true : false,
              date: moment.utc(survey.edited).local().format("YYYY-MM-DD HH:mm"),
              unix: moment.utc(survey.edited).format("X"),
              icon: Task.getTaskIcon(survey.operationPractice),
              color: Task.getTaskColor(survey.status),
              survey: true
            });
          }
        }
      }

      taskitems = [{ divider: true }, { name: "tasklistHeaderTasks", isHeader: true, taskHeader: true }].concat(taskitems);
      if (this.nextTaskPage && !this.hideTasks) {
        taskitems.push({ id: "taskIntersect", name: "", isTaskIntersect: true, disabled: true })
      }

      surveyitems = [{ divider: true }, { name: "tasklistHeaderSurveys", isHeader: true, surveyHeader: true }].concat(surveyitems);
      if (this.nextSurveyPage && !this.hideSurveys) {
        surveyitems.push({ id: "surveyIntersect", name: "", isSurveyIntersect: true, disabled: true })
      }

      this.items = status.concat(projects, taskitems, surveyitems);

      this.loading.updateTasks = false;
    },
    getRequestParams() {
      var params = ""

      // Status
      var selectionStatuses = this.computedSelection.filter((o) => o.isStatus === true);

      if (selectionStatuses.length > 0) {
        params += "&status="
        var statusses = []
        selectionStatuses.forEach(status => {
          statusses.push(status.dbId)
        });
        params += statusses.toString()
      }

      // Project
      var selectionProjects = this.computedSelection.filter((o) => o.isProject === true);
      if (selectionProjects.length > 0) {
        params += "&project="
        var projects = []
        selectionProjects.forEach(project => {
          projects.push(project.projectId)
        });
        params += projects.toString()
      }

      // Filter
      if (this.search) {
        params += "&filter=" + this.search
      }

      return params;
    },
    getTasks(next_page = false) {
      this.loading.getTasks = true;

      var page = (next_page && this.nextTaskPage) ? "?page=" + this.nextTaskPage : "?page=1"
      var params = page + this.getRequestParams()

      this.taskCancel = this.$axios.CancelToken.source();
      this.$axios
        .get(route("api.tasks.paginate") + params, {
          cancelToken: this.taskCancel.token,
        })
        .then((res) => {
          if (this.tasks.length > 0) {
            this.tasks = [...this.tasks, ...res.data.data];
          } else {
            this.tasks = res.data.data
          }

          if (res.data.next_page_url) {
            this.nextTaskPage = res.data.current_page + 1;
          } else {
            this.nextTaskPage = null
          }

          this.loading.getTasks = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.getTasks = false;
        });
    },
    getSurveys(next_page = false) {
      this.loading.getSurveys = true;

      var page = (next_page && this.nextSurveyPage) ? "?page=" + this.nextSurveyPage : "?page=1"
      var params = page + this.getRequestParams()

      this.surveyCancel = this.$axios.CancelToken.source();
      this.$axios
        .get(route("api.surveys") + params, {
          cancelToken: this.surveyCancel.token,
        })
        .then((res) => {
          if (this.surveys.length > 0) {
            this.surveys = [...this.surveys, ...res.data.data];
          } else {
            this.surveys = res.data.data
          }

          if (res.data.next_page_url) {
            this.nextSurveyPage = res.data.current_page + 1;
          } else {
            this.nextSurveyPage = null
          }

          this.loading.getSurveys = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.getSurveys = false;
        });
    },
    getProjects() {
      this.loading.getProjects = true;
      this.projects = [];
      this.$axios.get(route("api.projects")).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          const projectData = res.data[i]

          this.projects.push({
            id: "P" + projectData.projectId,
            projectId: projectData.projectId,
            name: projectData.name,
            active: projectData.active,
            isProject: true,
            icon: "mdi-folder-open",
            color: "green",
          });

          this.$projects.addProject(projectData)
        }
        this.loading.getProjects = false;
      });
    },
    openTask(item) {
      this.$emit("openTask", item.taskId);

      this.$refs.taskselect.blur();
      this.taskOpen = true;
    },
    resetTaskList() {
      console.log("reset tasklist")

      if (this.taskCancel) {
        this.taskCancel.cancel();
      }
      if (this.surveyCancel) {
        this.surveyCancel.cancel();
      }

      this.tasks = [];
      this.surveys = [];

      this.nextTaskPage = null;
      this.nextSurveyPage = null;
      this.updateTasks();

      this.$nextTick(() => {
        this.nextTaskPage = 1;
        this.nextSurveyPage = 1;
        this.updateTasks();
      });
    },
    showTaskList() {
      if (!this.$refs.taskselect) return;
      this.$nextTick(() => {
        this.$refs.taskselect.isMenuActive = true;
        this.$refs.taskselect.isFocused = true;
      });
    },
    hideTaskList() {
      this.$nextTick(() => {
        this.$refs.taskselect.isMenuActive = false;
        this.$refs.taskselect.isFocused = false;
      });
    },
    remove(item) {
      let copy = [...this.computedSelection]
      const index = copy.findIndex((o) => o.id === item.id);
      if (index >= 0) copy.splice(index, 1);
      this.computedSelection = copy
    },
    addTask() {
      this.$emit("menuSelected", "taskCreate");
    },
    menuIconClick() {
      this.$emit("menuListClick");
    },
  },
};
</script>

<style scoped>
#tasklist {
  z-index: 75;
  margin-left: 5px;
}

#tasklist form {
  display: flex;
  flex: 1 1 auto;
  margin: -12px;
}

.floating {
  position: absolute;
  top: 26px;
  left: 23px;
  width: 410px;
}

.inline {
  position: absolute;
  width: calc(100vw - 23px - 23px);
  top: 18px;
  left: 23px;
}
</style>

<style>
/* Manual fix for this bug: https://github.com/vuetifyjs/vuetify/issues/13133 */
/* v-autocomplete using item slot with v-list-item-title and v-list-item-subtitle is rendered too wide */
.v-autocomplete__content,
.v-list-item-bugfix {
  width: 390px !important;
  /* max-height: 80% !important;  */
  /** this breaks other autocompletes */
  /* this is just to increase the height */
}

#tasklist .v-list-item--highlighted,
.v-list-item--highlighted::before {
  opacity: 0 !important;
}

#tasklist .v-list-item--active,
.v-list-item--active::before {
  opacity: .12 !important;
}

#tasklist .v-input__slot {
  margin-bottom: 0px;
}

#tasklist .v-text-field__details {
  min-height: unset;
  height: 0px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px;
}
</style>